import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ClientPickerComponent } from '@modules/client/client-picker/client-picker.component';
import { Store } from '@ngrx/store';
import { FlattenedSequence } from '@pixacare/dtos';
import { TuiButton, TuiDialogContext, TuiIcon } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ClientData } from 'src/app/shared/models/base/client-data';
import { selectClient, selectClients } from 'src/app/shared/store/clients/clients.selectors';

@Component({
  templateUrl: './sequence-move.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, AsyncPipe, TuiIcon, ClientPickerComponent, TuiButton],
  host: {
    class: 'flex flex-col gap-3',
  },
})
export class SequenceMoveComponent implements OnInit {
  protected store = inject(Store);
  private readonly context = inject<
    TuiDialogContext<
      string,
      {
        flattenedSequence: FlattenedSequence;
      }
    >
  >(POLYMORPHEUS_CONTEXT, { optional: true });

  @Input() flattenedSequence: FlattenedSequence = this.context.data.flattenedSequence;

  fromClientName$: Observable<string>;
  movableClients$: Observable<{ [clientCode: string]: ClientData }>;
  toClientCode: string;

  ngOnInit(): void {
    this.fromClientName$ = this.store
      .select(selectClient(this.flattenedSequence.clientCode))
      .pipe(map((client) => client.fullName));

    this.movableClients$ = this.store.select(selectClients).pipe(
      map((clients) => {
        const movableClients = { ...clients };
        delete movableClients[this.flattenedSequence.clientCode];
        return movableClients;
      }),
    );

    this.movableClients$.pipe(first()).subscribe((clients) => {
      this.toClientCode = Object.keys(clients)[0];
    });
  }

  cancel(): void {
    this.context.completeWith(null);
  }

  move(): void {
    if (!this.toClientCode) {
      return;
    }

    this.context.completeWith(this.toClientCode);
  }
}
